import AdminOperatorDetails from './AdminOperatorDetails';
import AdminOperators from './AdminOperators';


export {
    AdminOperators,
    AdminOperatorDetails,
};

export default AdminOperators;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Operators/index.tsx